"use client";
import { EAELogo } from "@/assets/svg-icons/svg-icons";
import Button from "@/components/buttons";
import cn from "@/utils/cn";
import TextComponent from "../TextComponent";
import { PremiumCardMinimize, PremiumCardExpand } from "@/assets/svg-icons/svg-icons";
import { useEffect, useState } from "react";
import { useZStore } from "@/utils/z-store";

const PremiumCardUpgrade = ({ className }: { className?: string }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { data, actions } = useZStore();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerHeight >= 902) {
        // 2xl breakpoint
        setIsCollapsed(false);
      } else {
        setIsCollapsed(true);
      }
    };

    // Set initial state
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isCollapsed) {
    return (
      <div
        className={cn(
          "flex h-[45px] w-full cursor-pointer items-center justify-between gap-[11px] rounded-[12px] bg-kd-lte-blue p-[11px] text-white shadow-md shadow-kd-lte-blue/30",
          data.isBannerVisible ? "hidden" : "",
          className,
        )}
        onClick={() => setIsCollapsed(false)}
      >
        <div className="flex items-center gap-[8px] min-w-0">
          <div className="flex size-[25px] shrink-0 items-center justify-center rounded-[6.486px] bg-white">
            <EAELogo className="size-[19px]" />
          </div>
          <TextComponent type="h3" className="truncate">
            Premium Plan
          </TextComponent>
        </div>
        <PremiumCardExpand className="size-[19.5px] shrink-0" />
      </div>
    );
  }

  return (
    <div
      className={cn(
        "relative w-full rounded-[12px] xl:rounded-[20px] bg-kd-lte-blue p-6 text-center text-white shadow-md shadow-kd-lte-blue/50",
        "h-[195.75px] xl:h-[259px]",
        data.isBannerVisible ? "hidden" : "",
        className,
      )}
    >
      <div
        className="absolute right-3 top-3 cursor-pointer rounded-lg hover:bg-black/10"
        onClick={() => {
          setIsCollapsed(true);
        }}
      >
        <PremiumCardMinimize className="" />
      </div>

      <div className="mb-2 flex justify-center xl:mb-4">
        <div className="flex size-[36px] items-center justify-center rounded-xl bg-white xl:size-12 xl:rounded-[16px]">
          <EAELogo />
        </div>
      </div>

      <div className=" mx-auto w-[139px] xl:w-[146px]">
        <TextComponent type="h3" className="mb-[3px] xl:mb-2">
          Premium Plan
        </TextComponent>

        <TextComponent
          type="body"
          className="mb-[11px] text-[#FFFFFFCC] xl:mb-6"
        >
          Get access to all our exclusive features
        </TextComponent>
      </div>
      <Button
        variant="xxs"
        className="mx-auto h-[30px] w-[101.25px] text-nowrap bg-white text-kd-lte-blue xl:h-10 xl:w-[135px]"
        // disabled
        onClick={() => {
          actions.openModal({
            modalName: "billing-modal",
          });
        }}
      >
        <TextComponent type="button">Upgrade</TextComponent>
        {/* Coming Soon */}
      </Button>
    </div>
  );
};

export default PremiumCardUpgrade;
